import type React from 'react';
import InOfficeHoldNoteContext from './InOfficeHoldNoteContext';
import { hasInOfficeHoldNoteContent } from './inOfficeHoldNote';
import type { OriginEventRendererProps } from './types';

export type { OriginEventRendererProps } from './types';

export interface OriginEventRendererEntry {
    /** Whether the payload has anything worth showing for this type. */
    hasContent: (payload: Record<string, unknown>) => boolean;
    Component: React.FC<OriginEventRendererProps>;
}

/**
 * Origin-event `type` -> renderer for the amber "why this appointment" card's
 * event-specific body (see OdoContextCard). Add support for a new event type
 * by adding an entry here - OdoContextCard's dispatch, and its "render
 * nothing for an unrecognized type" fallback, never need to change.
 */
export const ORIGIN_EVENT_RENDERERS: Record<string, OriginEventRendererEntry> = {
    'in-office-hold-note': {
        hasContent: hasInOfficeHoldNoteContent,
        Component: InOfficeHoldNoteContext
    }
};
